import {ga4Event, removeErrorConfirm } from "./generaFunctions";
import axios from "axios";
import { sibGiftMsg } from "./sib.functions";

export const pauseSubscription = async (email, cycle) => {
    const response = await fetch('/wp-admin/admin-ajax.php?action=recurly_pause_subscription&email=' + encodeURIComponent(email) + '&cycle=' + cycle)
    return response.json();
}

export const cancelSubscription = async (email) => {
    const response = await fetch('/wp-admin/admin-ajax.php?action=recurly_cancel_subscription&email=' + encodeURIComponent(email))
    return response.json();
}

export const reactivateSubscription = async (email) => {
    const response = await fetch('/wp-admin/admin-ajax.php?action=recurly_reactivate_subscription&email=' + encodeURIComponent(email))
    return response.json();
}

export const getInfo = async (email) => {
    const response = await fetch("/wp-admin/admin-ajax.php?action=recurly_get_info&email=" + encodeURIComponent(email))
    return response.json();
}

export const getPlanInfo = async (plan) => {
    const response = await fetch("/wp-admin/admin-ajax.php?action=recurly_get_plan_info&plan=" + plan)
    return response.json();
}

export const checkInfo = async (email, address) => {
    const response = await fetch("/wp-admin/admin-ajax.php?action=recurly_check_info&email=" + encodeURIComponent(email) + "&address=" + address)
    return response.json();
}

export const updateBoxSeq = async (email, boxseq, addition = false) => {
    const response = await fetch("/wp-admin/admin-ajax.php?action=recurly_boxseq_update&email=" + encodeURIComponent(email) + "&boxseq=" + boxseq + (addition?"&addition=" + addition:""))
    return response.json();
}

export const addAddon = async (email, code) => {
    const response = await fetch('/wp-admin/admin-ajax.php?action=recurly_add_addon&email=' + encodeURIComponent(email) + '&code=' + code)
    return response.json();
}

export const getAddonList = async (plan) => {
    const response = await fetch('/wp-admin/admin-ajax.php?action=recurly_get_addon_list&plan=' + plan)
    return response.json();
  }

export const getCouponInfo = async (coupon_id) => {
    const response = await fetch('/wp-admin/admin-ajax.php?action=recurly_get_coupon_info&coupon_id=' + coupon_id)
    return response.json();
}

export const addCoupon = async (email, code) => {
    const response = await fetch('/wp-admin/admin-ajax.php?action=recurly_add_coupon&email=' + encodeURIComponent(email) + '&code=' + code)
    return response.json();
}

export const changeCustomField = async (email, c_name, c_value) => {
    const response = await fetch('/wp-admin/admin-ajax.php?action=recurly_custom_update&email=' + encodeURIComponent(email) + '&c_name=' + c_name + '&c_value=' + encodeURIComponent(c_value))
    return response.json();
}

export const changeNextBill = async (subs_id, next_bill_date) => {
    const response = await axios.post('/wp-admin/admin-ajax.php?action=recurly_align_date', { subs_id: subs_id,  next_bill_date:next_bill_date});
    try{
        return response.json();
    } catch {
        return response;
    }
}

export const validateAndSubmitSubs =(formData, cardBrand, callBack=null, payment_type=null, credit_token=null, recaptcha_value=null) => {
    const {pay_source, plan, email,ship_fname,ship_lname,ship_street,
    ship_apt, ship_city, ship_country, ship_state, ship_zip, ship_phone, gift,price, 
    giftee_email, bill_country, bill_zip, personal_msg} = formData;
    if(payment_type) formData["pay_source"] = payment_type;
    if(cardBrand)  formData["card_brand"] = cardBrand;
    if(credit_token) formData["recurly_token"] = credit_token;
    if(recaptcha_value) formData["recaptcha_value"] = recaptcha_value; 
    window.dataLayer.push({ ecommerce: null });
    let item_id = gift? "MTM_SUB_BOX_GIFT" : "MTM_SUB_BOX_NON_GIFT";
    let item_name = gift? "MTM Subscription Box - Gift" : "MTM Subscription Box - NonGift";
    window.dataLayer.push({
        event: "add_payment_info",
        ecommerce: {
            currency: "USD",
            payment_type: payment_type?payment_type:pay_source,
            value: 35,
            items: [
            {
                item_id: item_id,
                item_name: item_name,
                item_variant: plan,
                index: 0,
                price: 35,
                affiliation: "Miss To Mrs Box",
                currency: "USD",
                quantity: 1
            }
            ]
        }
    });
        axios.post('/wp-admin/admin-ajax.php?action=recurly_subs_purchase_mtm', formData)
        .then(response => {
          if(response.data.success) {
              window.sessionStorage.setItem("price", price );
              window.sessionStorage.setItem("email", email.trim().replaceAll(" ",""));
              window.sessionStorage.setItem("first-name",ship_fname);
              window.sessionStorage.setItem("last-name",ship_lname);
              window.sessionStorage.setItem("street",ship_street);
              window.sessionStorage.setItem("apt-unit",ship_apt);
              window.sessionStorage.setItem("city",ship_city);
              window.sessionStorage.setItem("country",ship_country);
              window.sessionStorage.setItem("state",ship_state);
              window.sessionStorage.setItem("zip-postal",ship_zip);
              window.sessionStorage.setItem("phone",ship_phone);
              window.sessionStorage.setItem("gift",gift);
              window.sessionStorage.setItem("recurly_invoice_id",response.data.invoice_id);
              window.sessionStorage.setItem("subscription_id",response.data.subscription_id);

              //billing information
              window.sessionStorage.setItem("billing_first_name",null);
              window.sessionStorage.setItem("billing_last_name",null);
              window.sessionStorage.setItem("billing_street1",null);
              window.sessionStorage.setItem("billing_region",null);
              window.sessionStorage.setItem("billing_postal_code",bill_zip);
              window.sessionStorage.setItem("billing_country",bill_country);

              ga4Event("checkout", "payment succeeded", item_name, `Plan: ${plan}, Email: ${email}, Country: ${ship_country}`);
              window.localStorage.setItem('formData', null);
              let queryString = window.location.search + "&rsid="+response.data.subscription_id;
              if(formData.personal_msg_checked){
                  window.sessionStorage.setItem("giftee_email",giftee_email);
                  window.sessionStorage.setItem("personal_msg",personal_msg);
                  sibGiftMsg(giftee_email,personal_msg).then((response)=>{
                      window.location.href = "/subscribe-thank-you/" + queryString;
                  });
              } /*else if(response.data.invoice_id){
                  //ri = recurly invoice id
                  window.location.href = "/subscribe-thank-you/" + queryString + "&ri=" + response.data.invoice_id;
              }*/else {
                  window.location.href = "/subscribe-thank-you/" + queryString;
              }
          } else if (response.data.action_token_id) {
              if(callBack) callBack(response.data.errors[0], response.data.action_token_id);
              return false;
          }else {
            if(callBack) callBack(response.data.errors[0]);
            return false;
          }
        }).catch(error=>{
          if(callBack) {
              if (error.response) {
                const errorMessage = error.response.data.errors[0];
                callBack(errorMessage);
              } else {
                callBack("Unknown Error");
              }    
            }
            return false;
        });
    }

export const addPaymentError = (element, title, message, redBorderEl, skipScroll = false, skipRemove = false) => {
    if(!skipScroll) element.scrollIntoView({behavior: 'smooth'});
    if(!skipRemove) removeErrorConfirm();
    
    const errorEl = document.createElement("div");
    errorEl.classList.add('checkout-payment-error');
    errorEl.classList.add('error-border');
    if(message){
      errorEl.innerHTML = `<div></div><div>${title}</div><div>${message.split("---")[0]}</div>`;
    } else {
      errorEl.style.opacity="0";
      errorEl.innerHTML = "empty";
    }
    if (redBorderEl) redBorderEl.classList.add('error-border');
    element.after(errorEl);
  } 